module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-cyrillic27.d09ca2b.woff2";